import type { NavImpactSurfaces } from '../arms';

export const spec = (): Partial<NavImpactSurfaces> => ({
  statStyle: 'delta_chip',
  statLayout: 'stacked',
});
